import React from 'react';
import {Col, Row} from "react-bootstrap";
import {t} from "react-switch-lang";
import FileUploadSection from "../../../../../../components/FileUploadSection/FileUploadSection";
import allowedFileTypes from "../../../../../../utils/allowedFileTypes";
import {downloadFile} from "../../../../../../services/externalizations/fileUploadService";

function FilesSection({disabled,removeFile,files,inputKey,handleFileUploadExternal, isUploading}) {
    return (<>
            <Row className="w-100 row">
                <Col className="col-6 col-xl-3">
                    <label style={{minHeight: '50px'}} className="label d-flex align-items-end w-100 mt-2">
                        {t('externalization.riskProponentForm.financialStatement')}
                    </label>
                    <FileUploadSection
                        className={'fileName'}
                        fieldName={'financialStatements'}
                        key={inputKey}
                        allowedFileTypes={allowedFileTypes}
                        disabled={disabled}
                        required={false}
                        multiple={true}
                        maxFiles={6}
                        fetchedFiles={(files?.financialStatements || [])
                            .filter(file => file && file?.id && file?.fileName)
                            .map(file => ({
                                ...file, label: file?.fileName, id: file?.id
                            }))}
                        onDeleteFetchedFile={(fileId) => removeFile('financialStatements', fileId)}
                        onNewFilesChange={(newFiles) => handleFileUploadExternal(newFiles, 'financialStatements', 'financial-statements')}
                        onFileDownload={(id, fileName) => downloadFile(id, fileName)}
                        isUploading={isUploading?.financialStatements}
                    />
                </Col>
                <Col className="col-6 col-xl-3">
                    <label style={{minHeight: '50px'}}
                           className="label d-flex align-items-end fileInputLabel w-100 mt-2">
                        {t('externalization.riskProponentForm.taxObligations')}
                    </label>
                    <FileUploadSection
                        className={'fileName'}
                        fieldName={'taxClearance'}
                        key={inputKey}
                        allowedFileTypes={allowedFileTypes}
                        disabled={disabled}
                        required={false}
                        multiple={true}
                        maxFiles={5}
                        fetchedFiles={(files?.taxClearance || [])
                            .filter(file => file && file?.id && file?.fileName)
                            .map(file => ({
                                ...file, label: file?.fileName, id: file?.id
                            }))}
                        onDeleteFetchedFile={(fileId) => removeFile('taxClearance', fileId)}
                        onNewFilesChange={(newFiles) => handleFileUploadExternal(newFiles, 'taxClearance', 'tax-clearance')}
                        onFileDownload={(id, fileName) => downloadFile(id, fileName)}
                        isUploading={isUploading?.taxClearance}
                    />
                </Col>
                <Col className="col-6 col-xl-3">
                    <label style={{minHeight: '50px'}}
                           className="label d-flex align-items-end fileInputLabel w-100 mt-2">
                        {t('externalization.riskProponentForm.CV')}
                      <span style={{paddingLeft: '45%', whiteSpace: 'pre'}}
                            className="optional register line-height">{t('common.optional')} </span>
                    </label>
                    <FileUploadSection
                        className={'fileName'}
                        fieldName={'keyPersonnelCv'}
                        key={inputKey}
                        allowedFileTypes={allowedFileTypes}
                        disabled={disabled}
                        required={false}
                        multiple={true}
                        maxFiles={5}
                        fetchedFiles={(files?.keyPersonnelCv || [])
                            .filter(file => file && file?.id && file?.fileName)
                            .map(file => ({
                                ...file, label: file?.fileName, id: file?.id
                            }))}
                        onDeleteFetchedFile={(fileId) => removeFile('keyPersonnelCv', fileId)}
                        onNewFilesChange={(newFiles) => handleFileUploadExternal(newFiles, 'keyPersonnelCv', 'key-personnel-cv')}
                        onFileDownload={(id, fileName) => downloadFile(id, fileName)}
                        isUploading={isUploading?.keyPersonnelCv}
                    />
                </Col>
                <Col className="col-6 col-xl-3">
                    <label style={{minHeight: '50px'}}
                           className="label d-flex align-items-end fileInputLabel w-100 mt-2">
                        {t('externalization.riskProponentForm.externalizationProposalJustification')}
                    </label>
                    <FileUploadSection
                        className={'fileName'}
                        fieldName={'externalizationProposalJustification'}
                        key={inputKey}
                        allowedFileTypes={allowedFileTypes}
                        disabled={disabled}
                        required={false}
                        multiple={true}
                        maxFiles={5}
                        fetchedFiles={(files?.externalizationProposalJustification || [])
                            .filter(file => file && file?.id && file?.fileName)
                            .map(file => ({
                                ...file, label: file?.fileName, id: file?.id
                            }))}
                        onDeleteFetchedFile={(fileId) => removeFile('externalizationProposalJustification', fileId)}
                        onNewFilesChange={(newFiles) => handleFileUploadExternal(newFiles, 'externalizationProposalJustification', 'externalization-proposal-justification')}
                        onFileDownload={(id, fileName) => downloadFile(id, fileName)}
                        isUploading={isUploading?.externalizationProposalJustification}
                    />
                </Col>
            </Row>
            <Row className="w-100 row">
                <Col className="col-6 col-xl-3">
                    <label style={{minHeight: '50px'}} className="label d-flex align-items-end w-100 mt-2">
                        {t('externalization.riskProponentForm.auditReport')}
                      <span style={{whiteSpace: 'pre'}}
                            className="optional register line-height">{t('common.optional')} </span>
                    </label>
                    <FileUploadSection
                        className={'fileName'}
                        fieldName={'auditReport'}
                        key={inputKey}
                        allowedFileTypes={allowedFileTypes}
                        disabled={disabled}
                        required={false}
                        multiple={true}
                        maxFiles={5}
                        fetchedFiles={(files?.auditReport || [])
                            .filter(file => file && file?.id && file?.fileName)
                            .map(file => ({
                                ...file, label: file?.fileName, id: file?.id
                            }))}
                        onDeleteFetchedFile={(fileId) => removeFile('auditReport', fileId)}
                        onNewFilesChange={(newFiles) => handleFileUploadExternal(newFiles, 'auditReport', 'audit-report')}
                        onFileDownload={(id, fileName) => downloadFile(id, fileName)}
                        isUploading={isUploading?.auditReport}
                    />
                </Col>
                <Col className="col-6 col-xl-3">
                    <label style={{minHeight: '50px'}}
                           className="label d-flex align-items-end fileInputLabel w-100 mt-2">
                        {t('externalization.riskProponentForm.licences')}
                      <span style={{paddingLeft: '53%', whiteSpace: 'pre'}}
                            className="optional register line-height">{t('common.optional')} </span>
                    </label>
                    <FileUploadSection
                        className={'fileName'}
                        fieldName={'licensesPermits'}
                        key={inputKey}
                        allowedFileTypes={allowedFileTypes}
                        disabled={disabled}
                        required={false}
                        multiple={true}
                        maxFiles={5}
                        fetchedFiles={(files?.licensesPermits || [])
                            .filter(file => file && file?.id && file?.fileName)
                            .map(file => ({
                                ...file, label: file?.fileName, id: file?.id
                            }))}
                        onDeleteFetchedFile={(fileId) => removeFile('licensesPermits', fileId)}
                        onNewFilesChange={(newFiles) => handleFileUploadExternal(newFiles, 'licensesPermits', 'licences-permits')}
                        onFileDownload={(id, fileName) => downloadFile(id, fileName)}
                        isUploading={isUploading?.licensesPermits}
                    />
                </Col>
                <Col className="col-6 col-xl-3">
                    <label style={{minHeight: '50px'}}
                           className="label d-flex align-items-end fileInputLabel w-100 mt-2">
                        {t('externalization.riskProponentForm.registerExtract')}
                    </label>
                    <FileUploadSection
                        className={'fileName'}
                        fieldName={'registryExtract'}
                        key={inputKey}
                        allowedFileTypes={allowedFileTypes}
                        disabled={disabled}
                        required={false}
                        multiple={true}
                        maxFiles={5}
                        fetchedFiles={(files?.registryExtract || [])
                            .filter(file => file && file?.id && file?.fileName)
                            .map(file => ({
                                ...file, label: file?.fileName, id: file?.id
                            }))}
                        onDeleteFetchedFile={(fileId) => removeFile('registryExtract', fileId)}
                        onNewFilesChange={(newFiles) => handleFileUploadExternal(newFiles, 'registryExtract', 'registry-extract')}
                        onFileDownload={(id, fileName) => downloadFile(id, fileName)}
                        isUploading={isUploading?.registryExtract}
                    />
                </Col>
                <Col className="col-6 col-xl-3">
                    <label style={{minHeight: '50px'}}
                           className="label d-flex align-items-end fileInputLabel w-100 mt-2">
                        {t('externalization.riskProponentForm.contractDraft')}
                        <span style={{paddingLeft: '59%', whiteSpace: 'pre'}}
                              className="optional register line-height">{t('common.optional')} </span>
                    </label>
                    <FileUploadSection
                        className={'fileName'}
                        fieldName={'contractDraft'}
                        key={inputKey}
                        allowedFileTypes={allowedFileTypes}
                        disabled={disabled}
                        required={false}
                        multiple={true}
                        maxFiles={5}
                        fetchedFiles={(files?.contractDraft || [])
                            .filter(file => file && file?.id && file?.fileName)
                            .map(file => ({
                                ...file, label: file?.fileName, id: file?.id
                            }))}
                        onDeleteFetchedFile={(fileId) => removeFile('contractDraft', fileId)}
                        onNewFilesChange={(newFiles) => handleFileUploadExternal(newFiles, 'contractDraft', 'contract-draft')}
                        onFileDownload={(id, fileName) => downloadFile(id, fileName)}
                        isUploading={isUploading?.contractDraft}
                    />
                </Col>
            </Row>
            <Row className="w-100 row">
                <Col className="col-6 col-xl-3">
                    <label style={{minHeight: '50px'}}
                           className="label d-flex align-items-end fileInputLabel w-100 mt-2">
                        {t('externalization.riskProponentForm.otherFiles')}
                        <span style={{paddingLeft: '62%', whiteSpace: 'pre'}}
                              className="optional register line-height">{t('common.optional')} </span>
                    </label>
                    <FileUploadSection
                        className={'fileName'}
                        fieldName={'otherFiles'}
                        key={inputKey}
                        allowedFileTypes={allowedFileTypes}
                        disabled={disabled}
                        required={false}
                        multiple={true}
                        maxFiles={5}
                        fetchedFiles={(files?.otherFiles || [])
                            .filter(file => file && file?.id && file?.fileName)
                            .map(file => ({
                                ...file, label: file?.fileName, id: file?.id
                            }))}
                        onDeleteFetchedFile={(fileId) => removeFile('otherFiles', fileId)}
                        onNewFilesChange={(newFiles) => handleFileUploadExternal(newFiles, 'otherFiles', 'other-proposal-form-related-files')}
                        onFileDownload={(id, fileName) => downloadFile(id, fileName)}
                        isUploading={isUploading?.otherFiles}
                    />
                </Col>
            </Row>
        </>);
}

export default FilesSection;